import fetcher_v2 from "@/api/fetcher_v2";
import * as Sentry from "@sentry/browser";

import { URLS } from "../urls";

// for future typescript:  { event: string, properties: Object}
export const postTrackingData = (
  event: string,
  properties: Record<string, unknown> = {}
) => {
  // Add screen resolution to properties
  const propertiesWithScreenResolution = {
    ...{
      screen: {
        width: window.screen.width,
        height: window.screen.height,
        density: window.devicePixelRatio,
      },
    },
    ...properties,
  };

  return fetcher_v2(URLS.TRACK, {
    method: "POST",
    body: { event, properties: propertiesWithScreenResolution },
    // tracking is something of an edge-case when it comes to error handling.
    // ideally the user should never be affected, we just want to swallow any errors and pass them to sentry for debugging.
  }).catch((err) => {
    Sentry.captureException(err);
  });
};
